"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRetryErrorSwrOptions = exports.getRetryErrorSwrInfiniteOptions = exports.basicSwrOptions = void 0;
var _axios = require("@ori/axios");
/* istanbul ignore file -- config */

const basicSwrOptions = exports.basicSwrOptions = {
  revalidateIfStale: false,
  revalidateOnFocus: false,
  revalidateOnReconnect: false
};
const ERROR_RETRY_COUNT = 3;
const ERROR_RETRY_INTERVAL = 2000;
const getRetryErrorSwrOptions = ({
  retryCount: retryCountParam = ERROR_RETRY_COUNT,
  retryInterval = ERROR_RETRY_INTERVAL
} = {}) => ({
  ...basicSwrOptions,
  shouldRetryOnError: true,
  errorRetryCount: retryCountParam,
  errorRetryInterval: retryInterval,
  // eslint-disable-next-line max-params -- library requires too many parameters
  onErrorRetry: (error, _, config, revalidate, {
    retryCount
  }) => {
    const statusCode = error.response?.status ?? _axios.HttpStatusCode.GatewayTimeout;
    if (statusCode >= _axios.HttpStatusCode.BadRequest && statusCode < _axios.HttpStatusCode.InternalServerError) {
      return;
    }
    if (retryCount >= (config.errorRetryCount ?? 0)) {
      return;
    }
    setTimeout(() => void revalidate({
      retryCount
    }), config.errorRetryInterval);
  }
});
exports.getRetryErrorSwrOptions = getRetryErrorSwrOptions;
const getRetryErrorSwrInfiniteOptions = ({
  retryCount: retryCountParam = ERROR_RETRY_COUNT,
  retryInterval = ERROR_RETRY_INTERVAL
} = {}) => ({
  ...basicSwrOptions,
  shouldRetryOnError: true,
  errorRetryCount: retryCountParam,
  errorRetryInterval: retryInterval,
  // eslint-disable-next-line max-params -- library requires too many parameters
  onErrorRetry: (error, _, config, revalidate, {
    retryCount
  }) => {
    const statusCode = error.response?.status ?? _axios.HttpStatusCode.GatewayTimeout;
    if (statusCode >= _axios.HttpStatusCode.BadRequest && statusCode < _axios.HttpStatusCode.InternalServerError) {
      return;
    }
    if (retryCount >= (config.errorRetryCount ?? 0)) {
      return;
    }
    setTimeout(() => void revalidate({
      retryCount
    }), config.errorRetryInterval);
  }
});
exports.getRetryErrorSwrInfiniteOptions = getRetryErrorSwrInfiniteOptions;
//# sourceMappingURL=swrConfig.js.map